export default __webpack_public_path__ + "static/media/mastercard-226450.1477c01e.svg";